import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { CostCenterWithAppointment } from "../models/cost-center/cost-center-with-appointment";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { ActionDataResult } from "../models/core/ActionDataResult";

@Injectable()
export class CostCentersService extends DataService<CostCenterWithAppointment, CostCenterWithAppointment> {
       
    constructor(
        protected http: HttpClient,
        protected notificationService: NotificationService) {
        super(http, notificationService);

        this.controllerName = 'cost-centers';
    }

    getAllWithAppointments(): Observable<CostCenterWithAppointment[]> {
        return this.getQuery(`${this.baseUrl()}/all-with-appointments`);
    }
}